import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  width = '100%',
  className = '',
  viewBox = '0 0 154 189.289',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Grupo_4649"
      data-name="Grupo 4649"
      transform="translate(-331 -318.711)"
    >
      <path
        id="people-carry-solid"
        d="M30.787,23.1A11.549,11.549,0,1,0,19.238,11.549,11.552,11.552,0,0,0,30.787,23.1Zm92.4,0a11.549,11.549,0,1,0-11.549-11.549A11.552,11.552,0,0,0,123.182,23.1Zm30.245,89.532L142.84,86.163l-9.889,11.164-.481,4.379,6.665,16.65a7.693,7.693,0,0,0,7.146,4.836,7.481,7.481,0,0,0,2.863-.553,7.7,7.7,0,0,0,4.283-10.009ZM145.2,62.15l-4.451-19.3a15.593,15.593,0,0,0-9.023-10.8,14.846,14.846,0,0,0-13.5.794,26.361,26.361,0,0,0-11.573,14.292l-2.719,8.157-3.85,2.454v-23.1a3.861,3.861,0,0,0-3.85-3.85h-38.5a3.861,3.861,0,0,0-3.85,3.85v23.1l-3.874-2.454-2.719-8.157A26.174,26.174,0,0,0,35.72,32.844a14.851,14.851,0,0,0-13.5-.794,15.593,15.593,0,0,0-9.023,10.8L8.771,62.15a15.416,15.416,0,0,0,3.465,13.643L28.4,94.056l2.43,22.281a7.706,7.706,0,0,0,7.651,6.857c.289,0,.553-.024.842-.048a7.687,7.687,0,0,0,6.809-8.494l-2.43-22.329A15.378,15.378,0,0,0,39.954,83.9L29.536,72.112,33.771,55.2l1.636,4.908a15.562,15.562,0,0,0,5.9,7.844l12.3,7.82a10.244,10.244,0,0,0,4.139,1.2h38.5a10.244,10.244,0,0,0,4.139-1.2l12.3-7.82a15.463,15.463,0,0,0,5.9-7.844L120.2,55.2l4.235,16.915L114.015,83.9a15.378,15.378,0,0,0-3.754,8.421l-2.43,22.329a7.7,7.7,0,0,0,6.809,8.494c.289.024.553.048.842.048a7.7,7.7,0,0,0,7.651-6.857l2.43-22.281,16.169-18.263A15.487,15.487,0,0,0,145.2,62.15ZM11.129,86.163.542,112.631a7.7,7.7,0,1,0,14.292,5.727l6.665-16.65-.481-4.379L11.129,86.163Z"
        transform="translate(331.016 384.806)"
        fill="#5a005a"
      />
      <path
        id="comments-dollar-solid"
        d="M60.626,55.318C60.626,42.439,47.055,32,30.313,32S0,42.439,0,55.318a19.789,19.789,0,0,0,5.534,13.4A32.621,32.621,0,0,1,.321,76.668a1.165,1.165,0,0,0,.845,1.967A25.643,25.643,0,0,0,14.1,74.995a36.99,36.99,0,0,0,16.216,3.64C47.055,78.635,60.626,68.2,60.626,55.318ZM27.981,69.308V66.934a8.345,8.345,0,0,1-4.572-1.654,1.167,1.167,0,0,1-.083-1.769l1.712-1.634a1.2,1.2,0,0,1,1.476-.106,3.509,3.509,0,0,0,1.868.542h4.1a1.832,1.832,0,0,0,1.72-1.922,1.9,1.9,0,0,0-1.278-1.855l-6.558-1.967a6.6,6.6,0,0,1-4.6-6.323,6.49,6.49,0,0,1,6.219-6.568V41.327a1.166,1.166,0,0,1,1.166-1.166h2.332a1.166,1.166,0,0,1,1.166,1.166V43.7a8.333,8.333,0,0,1,4.572,1.654,1.167,1.167,0,0,1,.083,1.769l-1.712,1.634a1.2,1.2,0,0,1-1.476.106,3.5,3.5,0,0,0-1.868-.542h-4.1a1.832,1.832,0,0,0-1.72,1.922A1.9,1.9,0,0,0,27.7,52.1l6.558,1.967a6.6,6.6,0,0,1,4.6,6.323,6.489,6.489,0,0,1-6.219,6.568v2.349a1.166,1.166,0,0,1-1.166,1.166H29.147a1.166,1.166,0,0,1-1.166-1.166Zm50.426,18.07a19.782,19.782,0,0,0,5.536-13.406c0-9.756-7.8-18.1-18.848-21.579a22.612,22.612,0,0,1,.194,2.925C65.289,70.747,49.6,83.3,30.313,83.3a43.464,43.464,0,0,1-4.624-.274c4.6,8.381,15.375,14.265,27.942,14.265a36.99,36.99,0,0,0,16.216-3.64,25.643,25.643,0,0,0,12.931,3.64,1.166,1.166,0,0,0,.844-1.969A32.5,32.5,0,0,1,78.407,87.378Z"
        transform="translate(366 286.711)"
        fill="#5a005a"
        opacity="0.5"
      />
      <path
        id="Exclusão_1"
        data-name="Exclusão 1"
        d="M-17291-6876h-.043a1.052,1.052,0,0,0,1.039-.99A1,1,0,0,1-17291-6876Zm-15.885,0h-4.223v-5.279a1.058,1.058,0,0,1,1.057-1.057h2.109a1.058,1.058,0,0,1,1.057,1.057V-6876Zm-20.123,0a1,1,0,0,1-.99-1v-.049a1.059,1.059,0,0,0,.99,1.047Zm37-3.231a1.052,1.052,0,0,0-1.047-.992h-1.057v-25.335h1.057a1.05,1.05,0,0,0,1.047-.987l0,27.314Zm-37.99,0h0V-6906.6a1.059,1.059,0,0,0,1.057,1.045h1.053v25.335h-1.053A1.056,1.056,0,0,0-17328-6879.23Zm25.332-5.214h-12.668a6.339,6.339,0,0,1,6.332-6.332,6.341,6.341,0,0,1,6.336,6.331Zm3.375-8.445h-2.531a.9.9,0,0,1-.844-.843v-2.536a.9.9,0,0,1,.844-.843h2.531a.913.913,0,0,1,.842.843v2.536A.913.913,0,0,1-17299.289-6892.89Zm-8.441,0h-2.535a.9.9,0,0,1-.844-.843v-2.536a.9.9,0,0,1,.844-.843h2.535a.9.9,0,0,1,.844.843v2.536A.9.9,0,0,1-17307.73-6892.89Zm-8.445,0h-2.535a.9.9,0,0,1-.844-.843v-2.536a.9.9,0,0,1,.844-.843h2.535a.9.9,0,0,1,.844.843v2.536A.9.9,0,0,1-17316.176-6892.89Zm16.887-6.332h-2.531a.914.914,0,0,1-.844-.844v-2.535a.914.914,0,0,1,.844-.844h2.531a.914.914,0,0,1,.842.844v2.535A.914.914,0,0,1-17299.289-6899.221Zm-8.441,0h-2.535a.914.914,0,0,1-.844-.844v-2.535a.914.914,0,0,1,.844-.844h2.535a.914.914,0,0,1,.844.844v2.535A.914.914,0,0,1-17307.73-6899.221Zm-8.445,0h-2.535a.914.914,0,0,1-.844-.844v-2.535a.914.914,0,0,1,.844-.844h2.535a.914.914,0,0,1,.844.844v2.535A.914.914,0,0,1-17316.176-6899.221Zm-11.822-9.518h0l0-.263a1,1,0,0,1,1-1h36a1,1,0,0,1,1,1v.213a1.058,1.058,0,0,0-1.051-.991h-35.891A1.059,1.059,0,0,0-17328-6908.739Z"
        transform="translate(17717 7331)"
        fill="#fff"
      />
      <rect
        id="Retângulo_4751"
        data-name="Retângulo 4751"
        width="5"
        height="39"
        transform="translate(388 419)"
        fill="#5a005a"
      />
      <rect
        id="Retângulo_4752"
        data-name="Retângulo 4752"
        width="43"
        height="5"
        transform="translate(387 418)"
        fill="#5a005a"
      />
      <rect
        id="Retângulo_4753"
        data-name="Retângulo 4753"
        width="10"
        height="36"
        transform="translate(420 420)"
        fill="#5a005a"
      />
    </g>
  </svg>
);

export default SVG;
